import React, { useEffect, useState, useContext } from "react"
import PropTypes from "prop-types"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Typography from "@mui/material/Typography"
import { Button, Checkbox, FormControlLabel, Box } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import i18n from "i18n"
import AuthContext from "context/auth/authContext"
import { getCurrency } from "utils/functions"

const ModalInvoiceDraftConfirm = ({
  open,
  onClose,
  onAccept,
  totalInvoicing,
  selectedPartsCount,
}) => {
  const { user } = useContext(AuthContext)
  const currencySymbol = getCurrency(user?.["custom:currency"])
  const [groupParts, setGroupParts] = useState(false)
  const partsLabel = i18n.t(
    selectedPartsCount === 1
      ? "certHistory.invoiceDraft.selectedPart_one"
      : "certHistory.invoiceDraft.selectedPart_other",
  )

  useEffect(() => {
    if (!open) {
      setGroupParts(false)
    }
  }, [open])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {i18n.t("certHistory.invoiceDraft.confirmTitle")}
        <IconButton
          aria-label={i18n.t("certHistory.invoiceDraft.closeAriaLabel")}
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {i18n.t("certHistory.invoiceDraft.confirmMessage", {
            amount: `${Number(totalInvoicing || 0).toFixed(2)} ${currencySymbol}`,
            count: selectedPartsCount,
            partsLabel,
          })}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={groupParts}
                onChange={event => setGroupParts(event.target.checked)}
              />
            }
            label={i18n.t("certHistory.invoiceDraft.groupParts")}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onClose} color="secondary" variant="text">
          {i18n.t("certHistory.invoiceDraft.cancel")}
        </Button>
        <Button
          onClick={() => onAccept(groupParts)}
          color="branded"
          variant="contained"
          sx={{ width: 175, height: 36 }}
        >
          {i18n.t("certHistory.invoiceDraft.accept")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ModalInvoiceDraftConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  totalInvoicing: PropTypes.number.isRequired,
  selectedPartsCount: PropTypes.number.isRequired,
}

export default ModalInvoiceDraftConfirm
